<template>
    <gofix-card class="mb-0" title="Fault Type" fullContent classContent="pd-0">
        <gofix-default-table :settings="tableConfig"
                :table-items="tableItems"
                @new-item="openModalCreate"
                @load-items="getTableData"
                @row-click="openModalEdit"
                @delete-items="deleteItems"
                ref="gofixTable">
                <template slot="gofix_table:description" slot-scope="row">
                    {{ row.item.description || "--"}}
                </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.title" hide-footer :centered="true" v-model="modals.open"  refs="modal-Create">
            <b-form class="pb-20">
                <gofix-form-input label="Fault Type Name" v-model="modals.data.fault_name"></gofix-form-input>
                <gofix-form-input-textarea label="Description" v-model="modals.data.description"></gofix-form-input-textarea>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="CANCEL" @click="modals.open = false" noBorder dark></gofix-button>
                <gofix-button label="OK" @click="saveItem" :loading="modals.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import { mapGetters } from 'vuex';
    export default {
        name: 'service-category-fault-type',
        components: {},
        props: {
            service_category_id: {
                type: Number,
                default: 0
            },
            contract_id: {
                type: Number,
                default: null
            },
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['sc_fault_type']));
            return {
                tableItems: [],
                tableConfig:{
                    name: 'client-contract-service-category-fault-type',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "fault_name",
                    sortDirection: "asc",
                },
                modals: {
                    title: 'Add Fault Type',
                    timer: null,
                    open: false,
                    loading: false,
                    data: {
                        id: 0,
                        service_category_id: 0,
                        fault_name: null,
                        description: null,
                        contract_id: null
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        created() {},
        watch: {
            service_category_id: function(val) {
                this.$refs.gofixTable.reloadTableKeepFilter()
            }
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.service_category_id = this.service_category_id
                await this.$store.dispatch("FaultTypeController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("FaultTypeController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'fault_type'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveItem() {
                if(!this.modals.data.service_category_id) {
                    return this.$alertNotification("Please select a service category", "danger");
                }

                if(!this.modals.data.fault_name) {
                    return this.$alertNotification("Fault Type Name is required", "danger");
                }

                if(this.modals.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                let api = 'createItem';
                let keyMsg = 'adding';
                if(this.modals.data.id) {
                    api = 'updateItem';
                    keyMsg = 'editing';
                }
                
                this.modals.timer = setTimeout(() => {
                    this.modals.loading = true;
                    this.$store.dispatch(`FaultTypeController/${api}`, this.modals.data)
                    .then(result => {
                        this.modals.open = false;
                        this.modals.loading = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMsg, 'fault_type'));
                    })
                    .catch(error => {
                        this.modals.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.error) {
                                return  this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                            this.$alertNotification("Error", "danger");
                        }                  
                    })
                }, 300)
            },
            openModalCreate() {
                this.modals.title = 'Add Fault Type';
                this.modals.data = Object.assign(this.modals.data, {
                    id: 0,
                    service_category_id: this.service_category_id,
                    fault_name: null,
                    description: null,
                    contract_id: this.contract_id
                })
                this.modals.open = true
            },
            openModalEdit(item) {
                if(item.service_category_id != this.service_category_id) {
                    return this.$alertNotification("You cannot modify the fault type of the parent node", "warning");
                }

                this.modals.title = 'Edit Fault Type';
                this.modals.data = Object.assign(this.modals.data, item)
                this.modals.open = true
            }
        }
    }
</script>
